import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { ParagraphApi } from './StrukturdatenParagraphApi';
import { FooterAbsatzApi } from './StrukturdatenFooterAbsatzApi';

/**
 * APIL Url: ADAC.Internet.Core.Models.Schadenmeldung.ZusammenfassungStruktur
 * Zusammenfassung des Schaden für das Deckblatt
 * Endpoints: /api/v2/versicherungen/fahrrad/v2/schaden, /api/schadenmeldungen/schutzbrief, /api/schadenmeldungen/aks, /api/schadenmeldungen/rrv, /api/schadenmeldungen/dokumentnachreichen
 */
export class ZusammenfassungStrukturApi extends BaseApiModel {
	constructor(initialProperties?: Partial<ZusammenfassungStrukturApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected title: string;
	/**
	 * Description: Titel des Dokuments: "Zusammenfassung Ihrer Online-Schadenmeldung"
	 * APIL Type: string
	 */
	get Title(): string {
		return this.title;
	}

	/**
	 * Description: Titel des Dokuments: "Zusammenfassung Ihrer Online-Schadenmeldung"
	 * APIL Type: string
	 */
	set Title(value: string) {
		this.title = value;
	}

	protected paragraphs: ParagraphApi[];
	/**
	 * Description: Liste der einzelnen Absätze
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Strukturdaten.Paragraph>
	 */
	get Paragraphs(): ParagraphApi[] {
		return this.paragraphs;
	}

	/**
	 * Description: Liste der einzelnen Absätze
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Strukturdaten.Paragraph>
	 */
	set Paragraphs(value: ParagraphApi[]) {
		this.paragraphs = value;
	}

	protected footer: FooterAbsatzApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Strukturdaten.FooterAbsatz
	 */
	get Footer(): FooterAbsatzApi {
		return this.footer;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Strukturdaten.FooterAbsatz
	 */
	set Footer(value: FooterAbsatzApi) {
		this.footer = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): ZusammenfassungStrukturApi {
		return AppUtils.Helper.createFromMap(dataObject, ZusammenfassungStrukturApi, (key, value) => {
			switch (key.toLowerCase()) {
				case 'paragraphs':
					const resultparagraphs = new Array<ParagraphApi>();
					if (value && Array.isArray(value)) {
						value.forEach((v: any) => {
							resultparagraphs.push(ParagraphApi.createFromObject(v));
						});
					}
					return resultparagraphs;
				case 'footer':
					return FooterAbsatzApi.createFromObject(value);
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Title = this.title;
		const paragraphsArrayReqObject: object[] = [];
		this.paragraphs.forEach((element) => {
			paragraphsArrayReqObject.push(element.toRequestObject());
		});
		result.Paragraphs = paragraphsArrayReqObject;
		if (this.footer) {
			result.Footer = this.footer.toRequestObject();
		}
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}